import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createBlock as _createBlock, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "card mb-25 border-0 rounded-0 bg-white add-user-card"
};
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-md-6" };
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_6 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_7 = ["placeholder", "required"];
const _hoisted_8 = { class: "col-md-6" };
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_10 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_11 = ["placeholder", "required"];
const _hoisted_12 = {
    key: 0,
    class: "col-md-6"
};
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_14 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_15 = ["placeholder", "required"];
const _hoisted_16 = {
    key: 1,
    class: "col-md-6"
};
const _hoisted_17 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_18 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_19 = ["placeholder", "disabled", "required"];
const _hoisted_20 = {
    key: 2,
    class: "col-md-6"
};
const _hoisted_21 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_22 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_23 = { class: "input-group" };
const _hoisted_24 = ["value"];
const _hoisted_25 = ["placeholder"];
const _hoisted_26 = {
    key: 3,
    class: "col-md-6"
};
const _hoisted_27 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_28 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_29 = { value: "Suisse" };
const _hoisted_30 = {
    key: 4,
    class: "col-md-6"
};
const _hoisted_31 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_32 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_33 = ["placeholder", "required"];
const _hoisted_34 = {
    key: 5,
    class: "col-md-6"
};
const _hoisted_35 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_36 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_37 = ["placeholder", "required"];
const _hoisted_38 = {
    key: 6,
    class: "col-md-6"
};
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_40 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_41 = ["placeholder", "required"];
const _hoisted_42 = {
    key: 7,
    class: "col-md-6"
};
const _hoisted_43 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_44 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_45 = ["placeholder"];
const _hoisted_46 = {
    key: 8,
    class: "col-md-6"
};
const _hoisted_47 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_48 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_49 = { value: "" };
const _hoisted_50 = { value: "ROLE_ADMIN" };
const _hoisted_51 = { value: "ROLE_FRANCHISE" };
const _hoisted_52 = { value: "ROLE_RESTAURANT" };
const _hoisted_53 = { value: "ROLE_USER" };
const _hoisted_54 = { value: "ROLE_GUEST" };
const _hoisted_55 = { value: "ROLE_SUPPORT_TECHNIQUE" };
const _hoisted_56 = { class: "col-md-12" };
const _hoisted_57 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_58 = ["disabled"];
const _hoisted_59 = { class: "position-relative" };
const _hoisted_60 = {
    key: 1,
    class: "card mb-25 border-0 rounded-0 bg-white add-user-card"
};
const _hoisted_61 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" };
const _hoisted_62 = { class: "row" };
const _hoisted_63 = { class: "col-md-6" };
const _hoisted_64 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_65 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_66 = ["placeholder"];
const _hoisted_67 = { class: "col-md-6" };
const _hoisted_68 = { class: "form-group mb-15 mb-sm-20 mb-md-25" };
const _hoisted_69 = { class: "d-block text-black fw-semibold mb-10" };
const _hoisted_70 = ["placeholder"];
const _hoisted_71 = { class: "col-md-12" };
const _hoisted_72 = { class: "d-flex align-items-center justify-content-between" };
const _hoisted_73 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.action === _ctx.ActionCrud.ADD || _ctx.action === _ctx.ActionCrud.EDIT)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("form", {
                        onSubmit: _cache[25] || (_cache[25] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.createNewAccount && _ctx.createNewAccount(...args)), ["prevent"]))
                    }, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('auth.firstName')) + " * ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.userData.firstName) }]),
                                        placeholder: _ctx.$t('forms.example') + ' Adam',
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.userData.firstName) = $event)),
                                        onChange: _cache[1] || (_cache[1] = (event) => _ctx.handleInput(event, 'firstName')),
                                        required: _ctx.actionDetected === _ctx.ActionCrud.ADD
                                    }, null, 42, _hoisted_7), [
                                        [_vModelText, _ctx.userData.firstName]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_8, [
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('auth.lastName')) + " * ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.userData.lastName) }]),
                                        placeholder: _ctx.$t('forms.example') + ' Smith',
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.userData.lastName) = $event)),
                                        onChange: _cache[3] || (_cache[3] = (event) => _ctx.handleInput(event, 'lastName')),
                                        required: _ctx.actionDetected === _ctx.ActionCrud.ADD
                                    }, null, 42, _hoisted_11), [
                                        [_vModelText, _ctx.userData.lastName]
                                    ])
                                ])
                            ]),
                            (!_ctx.isManagerMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                    _createElementVNode("div", _hoisted_13, [
                                        _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('auth.email')) + " * ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "email",
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.userData.email) = $event)),
                                            onChange: _cache[5] || (_cache[5] = (event) => _ctx.handleInput(event, 'email')),
                                            class: _normalizeClass([{ 'is-valid': _ctx.validEmail(_ctx.userData.email) }, "form-control shadow-none rounded-0 text-black"]),
                                            placeholder: _ctx.$t('forms.example') + ' adam127704@gmail.com',
                                            required: _ctx.actionDetected === _ctx.ActionCrud.ADD
                                        }, null, 42, _hoisted_15), [
                                            [_vModelText, _ctx.userData.email]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.isManagerMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                    _createElementVNode("div", _hoisted_17, [
                                        _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.$t('auth.password')) + " * ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "password",
                                            class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validPassword(_ctx.userData.password) }]),
                                            placeholder: _ctx.$t('forms.passwordPlaceholder'),
                                            "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.userData.password) = $event)),
                                            onChange: _cache[7] || (_cache[7] = (event) => _ctx.handleInput(event, 'password')),
                                            disabled: _ctx.actionDetected === _ctx.ActionCrud.EDIT,
                                            required: _ctx.actionDetected === _ctx.ActionCrud.ADD
                                        }, null, 42, _hoisted_19), [
                                            [_vModelText, _ctx.userData.password]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.isManagerMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createElementVNode("div", _hoisted_21, [
                                        _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.$t('forms.phoneNumber')), 1),
                                        _createElementVNode("div", _hoisted_23, [
                                            _withDirectives(_createElementVNode("select", {
                                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((_ctx.userData.phoneCountryCode) = $event)),
                                                class: "form-select shadow-none fw-semibold rounded-0",
                                                onChange: _cache[9] || (_cache[9] = (event) => _ctx.handleInput(event, 'phoneCountryCode')),
                                                style: { "max-width": "140px" }
                                            }, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.phoneCountryCodes, (country) => {
                                                    return (_openBlock(), _createElementBlock("option", {
                                                        key: country.code,
                                                        value: country.code
                                                    }, _toDisplayString(country.flag) + " " + _toDisplayString(country.prefix), 9, _hoisted_24));
                                                }), 128))
                                            ], 544), [
                                                [_vModelSelect, _ctx.userData.phoneCountryCode]
                                            ]),
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.userData.phoneNumber) }]),
                                                placeholder: _ctx.$t('forms.example') + ' 797070175',
                                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event) => ((_ctx.userData.phoneNumber) = $event)),
                                                onChange: _cache[11] || (_cache[11] = (event) => _ctx.handleInput(event, 'phoneNumber'))
                                            }, null, 42, _hoisted_25), [
                                                [_vModelText, _ctx.userData.phoneNumber]
                                            ])
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.isManagerMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                    _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t('forms.country')) + "* ", 1),
                                        _withDirectives(_createElementVNode("select", {
                                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event) => ((_ctx.userData.country) = $event)),
                                            class: _normalizeClass(["form-select shadow-none fw-semibold rounded-0", { 'is-valid': _ctx.validTextField(_ctx.userData.country) }]),
                                            onChange: _cache[13] || (_cache[13] = (event) => _ctx.handleInput(event, 'country'))
                                        }, [
                                            _createElementVNode("option", _hoisted_29, _toDisplayString(_ctx.$t('forms.switzerland')), 1)
                                        ], 34), [
                                            [_vModelSelect, _ctx.userData.country]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.isManagerMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                        _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t('forms.postalCode')) + " * ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.userData.postalCode) }]),
                                            placeholder: _ctx.$t('forms.example') + ' 1023',
                                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event) => ((_ctx.userData.postalCode) = $event)),
                                            onChange: _cache[15] || (_cache[15] = (event) => _ctx.handleInput(event, 'postalCode')),
                                            required: _ctx.actionDetected === _ctx.ActionCrud.ADD
                                        }, null, 42, _hoisted_33), [
                                            [_vModelText, _ctx.userData.postalCode]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.isManagerMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    _createElementVNode("div", _hoisted_35, [
                                        _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('forms.city')), 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.userData.city) }]),
                                            placeholder: _ctx.$t('forms.example') + ' Morges',
                                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event) => ((_ctx.userData.city) = $event)),
                                            onChange: _cache[17] || (_cache[17] = (event) => _ctx.handleInput(event, 'city')),
                                            required: _ctx.actionDetected === _ctx.ActionCrud.ADD
                                        }, null, 42, _hoisted_37), [
                                            [_vModelText, _ctx.userData.city]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.isManagerMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createElementVNode("div", _hoisted_39, [
                                        _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('forms.street')) + " * ", 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.userData.streetName) }]),
                                            placeholder: _ctx.$t('forms.example') + ' Chemin des maisons neuves',
                                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event) => ((_ctx.userData.streetName) = $event)),
                                            onChange: _cache[19] || (_cache[19] = (event) => _ctx.handleInput(event, 'streetName')),
                                            required: _ctx.actionDetected === _ctx.ActionCrud.ADD
                                        }, null, 42, _hoisted_41), [
                                            [_vModelText, _ctx.userData.streetName]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.isManagerMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                        _createElementVNode("label", _hoisted_44, _toDisplayString(_ctx.$t('forms.streetNumber')), 1),
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validTextField(_ctx.userData.numeroRue) }]),
                                            placeholder: _ctx.$t('forms.example') + ' 21',
                                            "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event) => ((_ctx.userData.numeroRue) = $event)),
                                            onChange: _cache[21] || (_cache[21] = (event) => _ctx.handleInput(event, 'numeroRue'))
                                        }, null, 42, _hoisted_45), [
                                            [_vModelText, _ctx.userData.numeroRue]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            (!_ctx.isManagerMode)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, [
                                        _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t('forms.role')), 1),
                                        _withDirectives(_createElementVNode("select", {
                                            class: _normalizeClass(["form-select shadow-none fw-semibold rounded-0", { 'is-valid': _ctx.validTextField(_ctx.userData.roles) }]),
                                            "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event) => ((_ctx.userData.roles) = $event)),
                                            onChange: _cache[23] || (_cache[23] = (event) => _ctx.handleInput(event, 'roles'))
                                        }, [
                                            _createElementVNode("option", _hoisted_49, _toDisplayString(_ctx.$t('forms.selectRole')), 1),
                                            _createElementVNode("option", _hoisted_50, _toDisplayString(_ctx.$t('header.administrator')), 1),
                                            _createElementVNode("option", _hoisted_51, _toDisplayString(_ctx.$t('roles.franchise')), 1),
                                            _createElementVNode("option", _hoisted_52, _toDisplayString(_ctx.$t('header.restaurant')), 1),
                                            _createElementVNode("option", _hoisted_53, _toDisplayString(_ctx.$t('roles.user')), 1),
                                            _createElementVNode("option", _hoisted_54, _toDisplayString(_ctx.$t('roles.guest')), 1),
                                            _createElementVNode("option", _hoisted_55, _toDisplayString(_ctx.$t('forms.technicalSupport')), 1)
                                        ], 34), [
                                            [_vModelSelect, _ctx.userData.roles]
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_56, [
                                _createElementVNode("div", _hoisted_57, [
                                    (_ctx.isLoading)
                                        ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValid }]),
                                            type: "submit",
                                            disabled: !_ctx.isFormValid
                                        }, _toDisplayString(_ctx.actionDetected === "edit"
                                            ? _ctx.$t('common.save')
                                            : _ctx.$t('lists.addUser')), 11, _hoisted_58)),
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: _cache[24] || (_cache[24] =
                                            //@ts-ignore
                                            (...args) => (_ctx.goBack && _ctx.goBack(...args))),
                                        class: "bg-transparent p-0 border-0 text-danger lh-1 fw-medium"
                                    }, [
                                        _cache[31] || (_cache[31] = _createElementVNode("i", { class: "flaticon-delete lh-1 me-1 position-relative top-2" }, null, -1)),
                                        _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('common.cancel')), 1)
                                    ])
                                ])
                            ])
                        ])
                    ], 32)
                ])
            ]))
            : _createCommentVNode("", true),
        (_ctx.action === 'password')
            ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
                _createElementVNode("div", _hoisted_61, [
                    _createElementVNode("form", {
                        onSubmit: _cache[30] || (_cache[30] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.updatePassword && _ctx.updatePassword(...args)), ["prevent"]))
                    }, [
                        _createElementVNode("div", _hoisted_62, [
                            _createElementVNode("div", _hoisted_63, [
                                _createElementVNode("div", _hoisted_64, [
                                    _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t('forms.oldPassword')) + " * ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "password",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", {
                                                'is-valid': _ctx.validPassword(_ctx.resetUserPassword.oldPassword),
                                            }]),
                                        placeholder: _ctx.$t('forms.passwordPlaceholder'),
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event) => ((_ctx.resetUserPassword.oldPassword) = $event)),
                                        onChange: _cache[27] || (_cache[27] = (event) => _ctx.handleInput(event, 'password'))
                                    }, null, 42, _hoisted_66), [
                                        [_vModelText, _ctx.resetUserPassword.oldPassword]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_67, [
                                _createElementVNode("div", _hoisted_68, [
                                    _createElementVNode("label", _hoisted_69, _toDisplayString(_ctx.$t('forms.newPassword')) + " * ", 1),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "password",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", {
                                                'is-valid': _ctx.validPassword(_ctx.resetUserPassword.newPassword),
                                            }]),
                                        placeholder: _ctx.$t('forms.passwordPlaceholder'),
                                        "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event) => ((_ctx.resetUserPassword.newPassword) = $event)),
                                        onChange: _cache[29] || (_cache[29] = (event) => _ctx.handleInput(event, 'password'))
                                    }, null, 42, _hoisted_70), [
                                        [_vModelText, _ctx.resetUserPassword.newPassword]
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_71, [
                                _createElementVNode("div", _hoisted_72, [
                                    (_ctx.isLoading)
                                        ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                        : (_openBlock(), _createElementBlock("button", {
                                            key: 1,
                                            class: _normalizeClass(["default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success", { 'opacity-50 cursor-not-allowed': !_ctx.isUpdateForm }]),
                                            type: "submit",
                                            disabled: !_ctx.isUpdateForm
                                        }, _toDisplayString(_ctx.$t('header.changePassword')), 11, _hoisted_73))
                                ])
                            ])
                        ])
                    ], 32)
                ])
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
